import React, { useEffect, useState } from "react";
import { Table, Button, Popover, OverlayTrigger } from "react-bootstrap";
import { apiUrl } from "../../config";
import { fetchAllUser } from "../../service/UserService";
import { Edit, Eye, Trash } from "lucide-react";

const PostsList = ({ posts, onEdit, onDelete, onView, deletingId }) => {

  const viewPopover = (
    <Popover id="popover-view">
      <Popover.Body>View Post details</Popover.Body>
    </Popover>
  );
  const editPopover = (
    <Popover id="popover-view">
      <Popover.Body>Edit Post details</Popover.Body>
    </Popover>
  );
  const deletePopover = (
    <Popover id="popover-view">
      <Popover.Body>Delete Post </Popover.Body>
    </Popover>
  );
  return (
    <Table className="custom-employee-table" bordered hover responsive>
      <thead>
        <tr>
          <th>S.No</th>
          <th>UserName</th>
          <th>Tags</th>
          <th>Title</th>
          <th>Image</th>
          {/* <th>Content</th> */}
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {posts.length > 0 ? (
          posts.map((post, idx) => {

            return (
              <tr key={post.postId}>
                <td>{idx + 1}</td>
                <td>{post?.username || "NA"}</td>
                <td>{post.tags}</td>
                <td>{post.title}</td>
                <td>
                  <img
                    src={apiUrl + "/" + post.bannerImageUrl}
                    // alt={pages.name}
                    className="student-thumbnail"
                    style={{
                      objectFit: "contain",
                      height: "70px",
                      width: "70px",
                    }}
                  />
                </td>
                {/* <td>
                  <div
                    style={{
                      maxWidth: "300px",
                      maxHeight: "20vh",
                      overflowY: "auto",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                    }}
                  >
                    {post.content}
                  </div>
                </td> */}
                <td>
                  <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="top"
                    overlay={viewPopover}
                  >
                    <Button
                      size="sm"
                      className="me-1"
                      style={{
                        backgroundColor: "#10296C",
                        padding: "5px",
                        borderRadius: "5px",
                        marginRight: "5px",
                      }}
                      onClick={() => onView(post)}
                    >
                      <Eye />
                    </Button>
                  </OverlayTrigger>
                  <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="top"
                    overlay={editPopover}
                  >
                    <Button
                      size="sm"
                      variant="warning"
                      className="me-1"
                      style={{
                        padding: "5px",
                        borderRadius: "5px",
                        marginRight: "5px",
                      }}
                      onClick={() => onEdit(post)}
                    >
                      <Edit />
                    </Button>
                  </OverlayTrigger>
                  <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="top"
                    overlay={deletePopover}
                  >
                    <Button
                      size="sm"
                      variant="danger"
                      style={{
                        padding: "5px",
                        borderRadius: "5px",
                        marginRight: "5px",
                      }}
                      onClick={() => onDelete(post.postId)}
                      disabled={post.id === deletingId}
                    >
                      {post.id === deletingId ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          Deleting...
                        </>
                      ) : (
                        <Trash />
                      )}
                    </Button>
                  </OverlayTrigger>
                </td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan="6" className="text-center">
              No advertisements found.
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default PostsList;
